import { defineInterface } from '@nzyme/ioc/Interface.js';
export const FileUploadUrlProvider = defineInterface({
    name: 'FileUploadUrlProvider',
});
//# sourceMappingURL=FileUploadUrlProvider.js.map